import React, { useState } from 'react';
import {
  Stack,
  Button,
  LinearProgress,
} from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import useOperationDictionary from '../hooks/useOperationDictionary';
import { ConfirmResultPatientByDoctor } from '../adapters/ConfirmResultPatientByDoctor';
import { UnConfirmResultPatientByDoctor } from '../adapters/UnConfirmResultPatientByDoctor';
import { useAtom } from 'jotai';
import { refetchAtom } from '../shared/refetch.shared.atom';
import { GetLabResultPatientReport } from '../adapters/GetLabResultPatientReport';

const LabPatientOperation = ({
  content,
  setForceRender,
}) => {
  const [, setRefetch] = useAtom(refetchAtom);

  const [loading, setLoading] = useState(false);

  const data = useOperationDictionary();

  const OperationBtn = ({ label, fn, disabled }) => {
    return (
      <Button
        disabled={disabled || loading}
        variant="contained"
        sx={{
          color: `${themeColors.ColorPrimary} !important`,
        }}
        onClick={() => {
          fn();
          setForceRender((prev) => !prev);
        }}
      >
        {label}
      </Button>
    );
  };

  return (
    <React.Fragment>
      <hr style={{ marginBlock: '1em' }} />
      {loading ? (
        <LinearProgress sx={{ mb: '.5em' }} />
      ) : (
        <></>
      )}
      <Stack gap=".5em" mb=".5em">
        <OperationBtn
          label={data[0]}
          fn={() => {
            SwalAlert('warning', data[4], true, () => {
              GetLabResultPatientReport(
                content?.FldId,
                setLoading
              );
            });
          }}
        />
        <OperationBtn
          disabled={content?.FldConfermDoctor}
          label={data[1]}
          fn={() => {
            SwalAlert('warning', data[5], true, () => {
              ConfirmResultPatientByDoctor(
                content?.FldId,
                setLoading,
                setRefetch
              );
            });
          }}
        />
        <OperationBtn
          label={data[2]}
          fn={() => {
            SwalAlert('warning', data[6], true, () => {
              UnConfirmResultPatientByDoctor(
                content?.FldId,
                setLoading,
                setRefetch
              );
            });
          }}
        />
        {/* <OperationBtn
          label={data[3]}
          fn={() => {
            SwalAlert('warning', data[7], true, () => {
              SwalAlert(
                'fire',
                '',
                true,
                () => {
                  RejectRequestResultPatientByDoctor(
                    content?.Id,
                    setLoading,
                    setRefetch
                  );
                },
                data[8],
                () => {},
                false
              );
            });
          }}
        /> */}
      </Stack>
    </React.Fragment>
  );
};

export default LabPatientOperation;
